import React from 'react';
import { Badge, PopoverBody, Popover } from 'reactstrap';
import classnames from 'classnames';

interface IBadgeWithTooltipProps {
  id?: string;
  targetId?: string;
  key?: string;
  color?: string;
  children?: any;
  placement?: string;
  tooltipText?: string;
}

interface IBadgeWithTooltipState {
  tooltipOpen: any;
}

export default class BadgeWithTooltip extends React.Component<
  IBadgeWithTooltipProps,
  IBadgeWithTooltipState
> {
  state = {
    tooltipOpen: false,
  };

  static defaultProps = {
    tooltipText: null,
  };

  toggleTooltip = () => {
    this.setState((previousState) => ({
      tooltipOpen: !previousState.tooltipOpen,
    }));
  };

  closeTooltip = () => {
    this.setState((previousState) => ({
      tooltipOpen: false,
    }));
  };

  render() {
    const elementExists = document.getElementById(this.props.targetId);

    return (
      <div
        className={classnames('d-inline-block', {
          'help-cursor': this.props.tooltipText !== null,
        })}
      >
        <div id={this.props.targetId}>
          <Badge {...this.props} />
        </div>
        {elementExists && this.props.tooltipText && (
          <Popover
            placement={this.props.placement || 'auto'}
            isOpen={this.state.tooltipOpen}
            target={this.props.targetId}
            onClick={this.closeTooltip}
            toggle={this.toggleTooltip}
          >
            <PopoverBody className="with-margin-top-10">{this.props.tooltipText}</PopoverBody>
          </Popover>
        )}
      </div>
    );
  }
}
